var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeviceActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#56A012",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.86 13.8594H20.14C15.65 13.8594 12 17.5094 12 21.9994C12 26.4894 15.65 30.1394 20.14 30.1394H23.86C28.35 30.1394 32 26.4894 32 21.9994C32 17.5094 28.35 13.8594 23.86 13.8594ZM23.86 26.4194C21.42 26.4194 19.44 24.4394 19.44 21.9994C19.44 19.5594 21.42 17.5794 23.86 17.5794C26.3 17.5794 28.28 19.5594 28.28 21.9994C28.28 24.4394 26.3 26.4194 23.86 26.4194Z",
    fill: "#56A012"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceActive);
export default __webpack_public_path__ + "static/media/device-active.fe6a577a0dafe45220452908e0c302b5.svg";
export { ForwardRef as ReactComponent };